<template>
  <div class="paper px-2 py-2">
    <div class="paper-title">
      <h3 v-if="showTitle" class="paper-title">{{paper.name}}</h3>
      <v-btn v-if="cfg.exportUrl" dark color="primary" @click="download(cfg.exportUrl)">导出</v-btn>
    </div>
    <p v-if="paper.desc" class="paper-desc">{{paper.desc}}</p>
    <div v-for="(g, gIndex) in groups" :key="g.id">
      <h5 class="ques-type">{{gIndex + 1}}. {{g.title}}</h5>
      <v-container fluid class="px-3 py-3 question-container" v-for="(q, qIndex) in qHash[g.id]" :key="q.id">
        <div class="sub-questions" v-if="q.question.type == 4">
          <div class="question">
            <p v-for="(pp, pIdx) in q.question.title.split('\n')" :key="pp">
              <span v-if="pIdx == 0">{{gIndex + 1}}.{{qIndex + 1}}.</span>
              <span v-html="pp"></span>
            </p>
          </div>
          <div class="ques-attachs" v-if="q.question.attachs && q.question.attachs.length > 0">
            <p v-for="a in q.question.attachs" :key="a">
              <img style="max-width:100%" :src="a" />
            </p>
          </div>
          <div class="sub-question" v-for="(sq, sqIndex) in q.question.subQues" :key="sq.id">
            <div class="question">
              <v-chip small color="green" text-color="white" v-if="logs[sq.id] && logs[sq.id].correct">
                正确（选择：{{logs[sq.id].answer}})</v-chip>
              <v-chip small color="red" text-color="white" v-else-if="logs[sq.id]">错误（选择：{{logs[sq.id].answer}})
              </v-chip>
              <div class="question-title">
                <p v-for="(p, idx) in sq.title.split('\n')" :key="p">
                  <span v-if="idx == 0">{{gIndex + 1}}.{{qIndex + 1}}.{{sqIndex + 1}}.</span>
                  <span v-html="p"></span>
                </p>
              </div>
              <div class="ques-attachs" v-if="sq.attachs && sq.attachs.length > 0">
                <p v-for="a in sq.attachs" :key="a">
                  <img style="max-width:100%" :src="a" />
                </p>
              </div>
            </div>
            <div class="answer-list">
              <div class="list-item" v-for="ans in sq.answers" :key="ans">
                <v-icon class="icon">panorama_fish_eye</v-icon>
                <span v-html="ans"></span>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="question">
            <v-chip small color="green" text-color="white" v-if="logs[q.question.id] && logs[q.question.id].correct">
              正确（选择：{{logs[q.question.id].answer}})</v-chip>
            <v-chip small color="red" text-color="white" v-else-if="logs[q.question.id]">
              错误（选择：{{logs[q.question.id].answer}})</v-chip>
            <div class="question-title">
              <p v-for="(p, idx) in q.question.title.split('\n')" :key="p">
                <span v-if="idx == 0">{{gIndex + 1}}.{{qIndex + 1}}.</span>
                <span v-html="p"></span>
              </p>
            </div>
            <div class="ques-attachs" v-if="q.question.attachs && q.question.attachs.length > 0">
              <p v-for="a in q.question.attachs" :key="a">
                <img style="max-width:100%" :src="a" />
              </p>
            </div>
          </div>
          <div class="answer-list">
            <div class="list-item" v-for="ans in q.question.answers" :key="ans">
              <v-icon class="icon">panorama_fish_eye</v-icon>
              <span v-html="ans"></span>
            </div>
          </div>
        </div>
      </v-container>
    </div>
  </div>
</template>

<script>
export default {
  name: "paper-view",
  props: {
    cfg: Object,
    showTitle: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      paper: {},
      groups: [],
      qHash: {},
      logs: {}
    };
  },
  watch: {
    cfg() {
      this.init();
    }
  },
  methods: {
    download(url) {
      window.open(url)
    },
    parseQuestion(q) {
      let self = this;
      if (q.attachs) {
        let attachs = q.attachs ? q.attachs.split(",") : [],
          rattachs = [];
        for (let a of attachs) {
          rattachs.push(
            `${self.$const.baseUrl}/home/my/question/img/${q.id}/${a.split("/")[0]
            }`
          );
        }
        q.attachs = rattachs;
      }
      q.type = self.$dictVal(q.type);
      if (q.type == 2) {
        q.answers = ["正确", "错误"];
      } else if (q.type == 4) {
        if (q.subQues) {
          q.subQues.forEach(e => {
            self.parseQuestion(e);
          });
        }
      } else {
        q.answers = [
          q.opt1 || "",
          q.opt2 || "",
          q.opt3 || "",
          q.opt4 || "",
          q.opt5 || "",
          q.opt6 || ""
        ].filter(ans => ans != "");
      }
    },
    init() {
      let self = this,
        cfg = self.cfg;
      self.logs = cfg.logs || {};
      self.$axios.get(`/home/my/paper/detail/${cfg.id}`).then(r => {
        if (r.data && r.data.status == "ok") {
          let paper = r.data.message,
            groups = r.data.groups,
            qHash = r.data.qHash;
          for (let k in qHash) {
            let qs = qHash[k];
            for (let q of qs) {
              self.parseQuestion(q.question);
            }
          }
          /* 筛选题目(抽题) */
          let draw = cfg.draw || null;
          if (draw) {
            Object.keys(qHash).forEach(groupId => {
              if (draw[groupId] && draw[groupId].length) {
                let questionSet = new Set(draw[groupId])
                qHash[groupId] = qHash[groupId].filter(q => questionSet.has(q.id))
              }
            })
          }

          self.qHash = qHash;
          self.groups = groups;
          self.paper = paper;
        }
      });
    }
  },
  created() {
    this.init();
  }
};
</script>

<style scoped>
.paper .paper-title {
  font-size: 24px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
}

.paper .ques-type {
  font-size: 16px;
  margin-bottom: 10px;
}

.question-container {
  margin-bottom: 20px;
  border: 1px solid #dedede;
}

.question-container .question {
  font-size: 16px;
}

.question-container .answer-list {
  margin-top: 10px;
  margin-left: 15px;
}

.question-container .answer-list .list-item {
  font-size: 14px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.question-container .answer-list .list-item .icon {
  font-size: 14px;
}

.question-container .answer-list .list-item span {
  margin-left: 5px;
}
</style>
